/** Relie l'entonnoir partagé au brouillon du risque physique. */
import PreventionFunnel from "@/components/prevention-funnel"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import physicalRiskStore from "../model/physical-risk.store"
import { PhysicalRisk } from "../model/physical-risk.types"

interface Props {
  isReadonly?: boolean
  risk?: PhysicalRisk
}

export default function PhysicalRiskPreventionFunnel({ isReadonly, risk }: Props) {
  const dispatch = useAppDispatch()
  const draft = useAppSelector(physicalRiskStore.selectors.draft)
  const showCalculations = useAppSelector((state) => state._session.userOptions.risksShowCalculations)
  const displayedRisk = risk ?? draft

  return (
    <PreventionFunnel
      scale={displayedRisk.cPreventionScale ?? []}
      value={displayedRisk.prevention}
      showValues={Boolean(risk) || showCalculations}
      onChange={isReadonly || risk ? undefined : (value) => dispatch(physicalRiskStore.thunks.edit({ key: "prevention", value }))}
    />
  )
}
